var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6155 7.01318L8.79276 7.01318L8.79276 1.52182L10.6155 1.52182C10.7175 1.52182 10.8153 1.56761 10.8874 1.64928C10.9595 1.73085 11 1.84156 11 1.95691L11 6.57805C11 6.69345 10.9595 6.80413 10.8874 6.88574C10.8153 6.96733 10.7174 7.01318 10.6155 7.01318Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.79279 7.01355L6.83935 10.5468C6.76364 10.6865 6.65726 10.8016 6.53057 10.8809C6.40388 10.9602 6.26119 11.001 6.11642 10.9994C6.00239 11.004 5.8887 10.9828 5.78207 10.9369C5.67542 10.8909 5.57801 10.8213 5.49555 10.7321C5.4131 10.6428 5.34729 10.5358 5.30203 10.4173C5.25676 10.2988 5.23294 10.1712 5.23199 10.0421L5.23199 7.50961L1.85575 7.50961C1.73102 7.50503 1.60854 7.47062 1.49637 7.40864C1.3842 7.34667 1.2849 7.25854 1.20498 7.15003C1.12505 7.04152 1.06637 6.91511 1.03273 6.77909C0.999084 6.64307 0.991255 6.50053 1.00978 6.36086L1.62505 1.87028C1.65126 1.63028 1.75412 1.4094 1.91412 1.24914C2.07413 1.08887 2.2804 1.00028 2.49413 1.00001L7.5392 1.00001C7.77937 0.998961 8.01641 1.0615 8.23137 1.18282L8.7851 1.49607",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.79279 7.01343L8.79279 1.52203",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeActive);
export default __webpack_public_path__ + "static/media/negative-active.4ce693e5d7adca44076ac7752978fcbf.svg";
export { ForwardRef as ReactComponent };